import React from "react";
import { Box, HStack, Text } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { NavbarMenu } from "./NavbarMenu";
import { HamburgerMenu } from "./HamburgerMenu";
import SideMenuArray from "../../Utils/SideMenuArray";

// Routes that aren't in the side menu but still deserve a readable title
const EXTRA_TITLES = {
  "/emailwithdraw-action": "Withdrawal Action",
  "/emailwithdraw-accept-reject": "Withdrawal Action",
};

export const Navbar = ({ setMobileOpen, leftOffset = 0 }) => {
  const screenWidth = useSelector((state) => state?.CurrentScreenWidth?.width);
  const location = useLocation();
  const isMobile = screenWidth < 769;

  const baseRoute = "/" + (location.pathname?.split("/")[1] || "");
  const current = SideMenuArray.find((item) => item.url === baseRoute);
  const title = current?.title || EXTRA_TITLES[baseRoute] || "";

  return (
    <HStack
      as="header"
      position="fixed"
      top="0"
      left={isMobile ? 0 : `${leftOffset}px`}
      right="0"
      zIndex="100"
      h="64px"
      px={{ base: 3, md: 6, lg: 8 }}
      gap={3}
      justifyContent="space-between"
      bg="rgba(255, 255, 255, 0.85)"
      backdropFilter="saturate(180%) blur(8px)"
      borderBottom="1px solid"
      borderColor="border.subtle"
      transition="left 240ms ease"
    >
      <HStack gap={3} minW={0}>
        {isMobile && <HamburgerMenu setMobileOpen={setMobileOpen} />}
        <Box minW={0}>
          {current?.section && (
            <Text fontSize="xs" color="fg.subtle" fontWeight="500" lineHeight="1.2">
              {current.section}
            </Text>
          )}
          <Text
            as="h1"
            fontSize={{ base: "md", md: "lg" }}
            fontWeight="600"
            color="fg.default"
            letterSpacing="-0.01em"
            lineClamp={1}
          >
            {title}
          </Text>
        </Box>
      </HStack>
      <NavbarMenu />
    </HStack>
  );
};
